import { RAW_TEXT_BLOCK } from '@tribeplatform/slate-kit/constants';
import { BlockType } from '../../types/index.js';
import { TextBlock as Component } from './Block.js';
export const RegisteredTextBlock = (_intl) => ({
    recommendedName: RAW_TEXT_BLOCK,
    Component,
    config: {
        type: BlockType.BuildingBlock,
        defaultProps: {
            value: '',
            size: 'sm',
            format: 'plain',
        },
    },
});
//# sourceMappingURL=registered.js.map